// story script using this script is here:
// 20150805_release/cq-core/foxsports/foxsports-core-ui/src/main/content/jcr_root/etc/designs/fsdigital/foxsports/assets/apps/storyapp/scripts/factories/storyEvents.service.js

var fsStoryVideoLoader = (function(criticalVideoLoader) {

	var loader = window.criticalVideoLoader;
	// if autoplaynum is specified, *only* allows autoplaynum number of videos to
	// be autoplayed and redefines autoplay as false for remaining video data
	// before initialization
	//
	loader.start = function (storyIndex, autoplaynum) {
		autoplaynum = typeof autoplaynum === 'number' ? autoplaynum : Infinity;

		var videos = loader.getVideoElementsData().map(function (data) {
			
			if (loader.isVideoDataAutoplay(data) && 0 >= autoplaynum--) {
				data.autoplay = false;
			}

			return data;
		});
		loader.loadScript(loader.loadVideos.bind(loader), videos, true);			
	};

	return loader;
}(criticalVideoLoader));


export default fsStoryVideoLoader;



// WEBPACK FOOTER //
// ./assets/components/platformPlayer/fsStoryVideoLoader.js